import { useParams, useNavigate } from "react-router-dom";
import useFetchCategoryQuestions from "../hooks/useFetchCategoryQuestions";
import "./AdminCategoryQuestionList.css";

export default function AdminCategoryQuestionsScreen() {

    const { domainId, categoryId } = useParams();
    const { questions, loadingQuestions } = useFetchCategoryQuestions(domainId, categoryId);
    const navigate = useNavigate();

    const handleBack = () => navigate(-1);
    const handleCreateQuestion = () => navigate(`/admin/domain/${domainId}/${categoryId}/create-question`);
    const handleEditQuestion = (questionId) => navigate(`/admin/domain/${domainId}/${categoryId}/create-question/${questionId}`);

    return (
        <div className="all-questions-page">
            <div className="questions-header">
                <h1 className="page-title">All Questions</h1>
                <div className="action-buttons">
                    <button className="primary-btn" onClick={handleCreateQuestion}>
                        ➕ Create Question
                    </button>
                    <button className="secondary-btn" onClick={handleBack}>
                        ← Back
                    </button>
                </div>
            </div>

            {loadingQuestions ? (
                <p className="info-text">Loading questions...</p>
            ) : questions.length === 0 ? (
                <p className="info-text">No questions found.</p>
            ) : (
                <div className="question-grid">
                    {questions.map((q) => {
                        const isCode =
                            q.question?.includes("class ") ||
                            q.question?.includes("function ") ||
                            q.question?.includes("def ") ||
                            q.question?.includes("{") ||
                            q.question?.includes("=>");

                        return (
                            <div
                                key={q.id}
                                className="question-card"
                                onClick={() => handleEditQuestion(q.id)}
                            >
                                <div className="question-header">
                                    <span className="question-number">
                                        {q.questionNumber ? `#${q.questionNumber}` : ""}
                                    </span>
                                    <span className="order-id">
                                        Order: {q.orderId || "-"}
                                    </span>
                                </div>

                                <div className="question-body">
                                    {isCode ? (
                                        <pre className="question-code">
                                            <code>{q.question}</code>
                                        </pre>
                                    ) : (
                                        <p className="question-text">
                                            {q.question || q.text || "Untitled Question"}
                                        </p>
                                    )}

                                </div>

                                <div className="card-footer">
                                    <button className="edit-btn">✏️ Edit</button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
